const pt = {
  // Navigation
  nav_home: 'Início',
  nav_about: 'Sobre Nós',
  nav_services: 'Serviços',
  nav_fleet: 'Frota',
  nav_schedules: 'Horários',
  nav_amenities: 'Comodidades',
  nav_contact: 'Contato',
  nav_bookNow: 'Reservar',

  // Common
  common_backHome: 'Voltar ao Início',

  // Hero
  hero_tagline: 'Viagem Interurbana Premium · Panamá',
  hero_h1_line1: 'Experiencie',
  hero_h1_line2: 'Viagens de Luxo',
  hero_h1_line3: 'pelo Panamá',
  hero_subtitle: 'A Phoenix Transportation redefine as viagens interurbanas entre a Cidade do Panamá e Chitré — combinando conforto de primeira classe, serviço profissional e absoluta confiabilidade.',
  hero_cta1: 'Reserve sua Viagem',
  hero_cta2: 'Conheça Nossa Frota',
  hero_card_dailyDeparture: 'Partida Diária',
  hero_card_perSeat: 'A Partir por Assento',
  hero_card_journeyTime: 'Tempo de Viagem',
  hero_scroll: 'Rolar',

  // About
  about_eyebrow: 'Sobre a Phoenix Transportation',
  about_h2_line1: 'Redefinindo',
  about_h2_line2: 'as Viagens',
  about_h2_line3: 'no Panamá',
  about_p1: 'A Phoenix Transportation é um serviço de ônibus de luxo dedicado a fornecer transporte interurbano seguro, confortável e confiável entre a <strong>Cidade do Panamá e Chitré</strong>.',
  about_p2: 'Projetada para atender à crescente demanda por opções de viagem premium, a empresa combina padrões elevados de frota com eficiência operacional — trazendo um novo nível de sofisticação às rotas interurbanas do Panamá.',
  about_p3: 'Acreditamos que cada viagem deve ser um prazer. Nossa equipe de profissionais treinados está comprometida em tornar sua experiência de viagem perfeita do início ao fim.',
  about_motto: 'Luxo. Segurança. Confiabilidade.',
  about_stat_buses: 'Ônibus de Luxo',
  about_stat_seats: 'Assentos Premium',
  about_stat_service: 'Serviço Diário',
  about_stat_route: 'Cidade a Cidade',

  // Services
  services_eyebrow: 'Nossos Serviços',
  services_h2_line1: 'Soluções de',
  services_h2_line2: 'Viagem Completas',
  services_subtitle: 'Cada aspecto da sua viagem é cuidadosamente elaborado para oferecer o mais alto padrão de transporte interurbano no Panamá.',
  services_0_title: 'Rotas Expressas Interurbanas',
  services_0_desc: 'Serviço direto e sem paradas entre a Cidade do Panamá e Chitré com partida diária. Nossa rota expressa é projetada para viajantes que valorizam pontualidade e conforto acima de tudo.',
  services_1_title: 'Assentos e Conforto Premium',
  services_1_desc: 'Todo assento é premium. Aproveite cadeiras de couro reclináveis espaçosas, amplo espaço para as pernas e controle individual de clima — tudo projetado para o viajante exigente.',
  services_2_title: 'Segurança e Confiabilidade',
  services_2_desc: 'Nossos motoristas certificados seguem protocolos rigorosos de segurança em cada rota. Os ônibus são mantidos e inspecionados regularmente para garantir que você sempre viaje com total tranquilidade.',
  services_3_title: 'Serviço de Concierge Profissional',
  services_3_desc: 'Nossa equipe a bordo garante uma experiência de viagem perfeita. Do embarque ao suporte durante o trajeto, oferecemos serviço de nível hoteleiro em cada quilômetro.',
  services_4_title: 'Conectividade a Bordo',
  services_4_desc: 'Fique conectado durante toda a viagem com Wi-Fi de alta velocidade gratuito. Seja para trabalho ou lazer, mantemos você online e produtivo em cada viagem.',
  services_5_title: 'Assistência com Bagagem',
  services_5_desc: 'Manuseio de bagagem gratuito para todos os passageiros. Nossa equipe auxilia no carregamento e descarregamento, para que você possa se concentrar na viagem sem preocupações.',

  // Fleet Home Section
  fleet_eyebrow: 'Nossa Frota',
  fleet_h2_line1: 'Ônibus de Luxo',
  fleet_h2_line2: 'para seu Conforto',
  fleet_subtitle: 'Nossa frota de 2 coaches de luxo de última geração é meticulosamente mantida para oferecer a melhor experiência de viagem em cada rota.',
  fleet_specs_title: 'Especificações da Frota',
  fleet_spec_0: '57 Assentos Premium',
  fleet_spec_1: 'Ar-Condicionado Completo',
  fleet_spec_2: 'Wi-Fi a Bordo',
  fleet_spec_3: 'Amplo Espaço para Pernas',
  fleet_spec_4: 'Motoristas Profissionais',
  fleet_spec_5: 'Certificação de Segurança',
  fleet_spec_6: 'Compartimento de Bagagem',
  fleet_spec_7: 'Portas de Carregamento USB',
  fleet_bookSeat: 'Reservar um Assento',
  fleet_route_departure_label: 'Partida',
  fleet_route_arrival_label: 'Chegada',
  fleet_route_duration_label: 'Duração',
  fleet_route_trips_label: 'Viagens Diárias',
  fleet_route_class_label: 'Classe',
  fleet_route_duration_val: '~3,5 Horas',
  fleet_route_trips_val: '1 Partida',
  fleet_route_class_val: 'Luxo',

  // Contact
  contact_eyebrow: 'Entre em Contato',
  contact_h2_line1: 'Comece sua',
  contact_h2_line2: 'Viagem Hoje',
  contact_phone_label: 'Telefone',
  contact_email_label: 'E-mail',
  contact_route_label: 'Rota',
  contact_hours_label: 'Horário de Serviço',
  contact_hours_val: 'Partida Diária: 4:00 AM',
  contact_form_fullName: 'Nome Completo',
  contact_form_fullName_ph: 'Seu nome completo',
  contact_form_email: 'E-mail',
  contact_form_email_ph: 'seu@email.com',
  contact_form_phone: 'Número de Telefone',
  contact_form_phone_ph: '+507 0000-0000',
  contact_form_travelDate: 'Data de Viagem',
  contact_form_route: 'Rota',
  contact_form_route_ph: 'Selecione sua rota',
  contact_form_route_opt1: 'Cidade do Panamá → Chitré',
  contact_form_route_opt2: 'Chitré → Cidade do Panamá',
  contact_form_route_opt3: 'Ida e Volta',
  contact_form_message: 'Mensagem',
  contact_form_message_ph: 'Pedidos especiais ou dúvidas...',
  contact_form_submit: 'Enviar Consulta',
  contact_form_sending: 'Enviando...',
  contact_form_note: 'Respondemos em até 24 horas',
  contact_form_required: 'obrigatório',
  contact_success_title: 'Mensagem Recebida!',
  contact_success_desc: 'Obrigado por entrar em contato com a Phoenix Transportation. Retornaremos em até 24 horas.',

  // Footer
  footer_tagline: 'Serviço de ônibus interurbano de luxo conectando a Cidade do Panamá e Chitré com conforto, segurança e estilo.',
  footer_motto: 'Luxo. Segurança. Confiabilidade.',
  footer_quickLinks: 'Links Rápidos',
  footer_routes: 'Rotas',
  footer_contact: 'Contato',
  footer_route1: 'Cidade do Panamá → Chitré',
  footer_route2: 'Chitré → Cidade do Panamá',
  footer_departure_label: 'Partida Diária',
  footer_departure_val: '4:00 AM Todo Dia',
  footer_journey_label: 'Tempo de Viagem',
  footer_journey_val: '~3,5 Horas',
  footer_privacy: 'Política de Privacidade',
  footer_terms: 'Termos de Serviço',

  // Schedules Page
  sched_backHome: 'Voltar ao Início',
  sched_title: 'Rotas e Horários',
  sched_subtitle: 'Reserve seu assento em nossa partida de luxo diária — partindo às 4:00 AM da Cidade do Panamá e de Chitré',
  sched_stat_distance_label: 'Distância',
  sched_stat_duration_label: 'Duração',
  sched_stat_departures_label: 'Partidas Diárias',
  sched_stat_price_label: 'A Partir de',
  sched_stat_price_val: '$9 por Assento',
  sched_stat_departures_val: '1 por Direção',
  sched_oneWay: 'Somente Ida',
  sched_roundTrip: 'Ida e Volta',
  sched_roundTrip_note: 'Selecione uma partida de cada coluna — mostraremos o total antes de você reservar.',
  sched_col1_title: 'Cidade do Panamá → Chitré',
  sched_col1_sub_ow: 'Partindo da Cidade do Panamá',
  sched_col1_sub_rt: 'Selecione sua partida de ida',
  sched_col2_title: 'Chitré → Cidade do Panamá',
  sched_col2_sub_ow: 'Partindo de Chitré',
  sched_col2_sub_rt: 'Selecione sua partida de retorno',
  sched_selected_badge: 'Selecionado',
  sched_price_label: 'Preço',
  sched_bookNow: 'Reservar Agora',
  sched_select: 'Selecionar',
  sched_selected_btn: 'Selecionado',
  sched_summary_outbound: 'Ida',
  sched_summary_return: 'Retorno',
  sched_summary_total: 'Total',
  sched_not_selected: 'Não selecionado',
  sched_outbound_detail: 'Cidade do Panamá → Chitré',
  sched_return_detail: 'Chitré → Cidade do Panamá',
  sched_bookRoundTrip: 'Reservar Ida e Volta',
  sched_selectBothLegs: 'Selecione Ambos os Trajetos para Continuar',
  sched_terminals_eyebrow: 'Pontos de Embarque',
  sched_terminals_title: 'Localizações dos Terminais',
  sched_terminals_subtitle: 'Encontre-nos nesses terminais. Chegue pelo menos 20 minutos antes do seu horário de partida.',
  sched_terminal_address: 'Endereço',
  sched_terminal_phone: 'Telefone',
  sched_terminal_hours: 'Horário do Terminal',
  sched_info_title: 'Informações Importantes',
  sched_info_checkin_title: 'Horário de Embarque',
  sched_info_checkin_desc: 'Por favor, chegue ao terminal pelo menos 20 minutos antes do horário de partida',
  sched_info_baggage_title: 'Política de Bagagem',
  sched_info_baggage_desc: '2 malas de mão (máx 10kg cada) e 2 malas despachadas (máx 23kg cada) incluídas',
  sched_info_cancel_title: 'Política de Cancelamento',
  sched_info_cancel_desc: 'Cancelamento gratuito até 24 horas antes da partida. Reembolso de 50% dentro de 24 horas',
  sched_info_ticket_title: 'Validação do Bilhete',
  sched_info_ticket_desc: 'Documento de identidade válido emitido pelo governo obrigatório. Bilhetes digitais ou impressos aceitos',

  // Amenities Page
  amen_eyebrow: 'Experiência a Bordo',
  amen_title1: 'Comodidades',
  amen_title2: 'Premium',
  amen_subtitle: 'Cada detalhe a bordo é cuidadosamente elaborado para garantir que sua viagem seja tão agradável quanto o destino.',
  amen_stat1_val: '7',
  amen_stat1_label: 'Recursos Premium',
  amen_stat2_val: '100%',
  amen_stat2_label: 'Conforto Garantido',
  amen_stat3_val: '248 km',
  amen_stat3_label: 'Rota de Luxo',
  amen_wifi_title: 'Wi-Fi de Alta Velocidade',
  amen_wifi_desc: 'Fique conectado durante toda a viagem com Wi-Fi de alta velocidade gratuito, mantendo você produtivo e entretido.',
  amen_wifi_detail: 'Nosso Wi-Fi a bordo é alimentado por uma conexão via satélite dedicada, garantindo velocidades estáveis mesmo na estrada.',
  amen_ac_title: 'Ar-Condicionado Completo',
  amen_ac_desc: 'Zonas climáticas individuais garantem que cada passageiro desfrute da temperatura perfeita, independente do calor tropical do Panamá lá fora.',
  amen_ac_detail: 'Cada seção do ônibus mantém sua própria zona climática com controle preciso de temperatura. Sem mais disputas pelo termostato — todos viajam com conforto.',
  amen_seats_title: 'Assentos de Couro Espaçosos',
  amen_seats_desc: 'Assentos de couro premium e amplos projetados para o máximo conforto — dando a cada passageiro o espaço que merece em cada viagem.',
  amen_seats_detail: 'Nossos assentos são fabricados com couro de grão completo com suporte lombar ergonômico. Com assentos extra-largos e amplo espaço para as pernas, cada viagem parece primeira classe.',
  amen_recline_title: 'Assentos Totalmente Reclináveis',
  amen_recline_desc: 'Ajuste seu assento para o ângulo perfeito e acomode-se para a viagem. Nossos assentos totalmente reclináveis permitem que você viaje em total relaxamento.',
  amen_recline_detail: 'Cada assento recline suavemente para o ângulo de sua preferência com um simples pressionar de botão. Seu assento se adapta a você.',
  amen_screen_title: 'Telas de Entretenimento',
  amen_screen_desc: 'Aproveite o entretenimento a bordo com telas individuais com filmes, música e conteúdo selecionado para fazer os quilômetros passarem voando.',
  amen_screen_detail: 'Cada assento possui uma tela touchscreen HD pessoal carregada com uma biblioteca de filmes, séries, músicas e podcasts.',
  amen_usb_title: 'Portas de Carregamento USB',
  amen_usb_desc: 'Cada assento possui portas de carregamento USB individuais para que seus dispositivos permaneçam totalmente carregados durante toda a viagem.',
  amen_usb_detail: 'Nunca chegue com a bateria descarregada. Cada assento inclui uma porta USB-A e USB-C com carregamento rápido.',
  amen_luggage_title: 'Armazenamento Seguro de Bagagem',
  amen_luggage_desc: 'Grandes compartimentos de bagagem e armazenamento superior mantêm seus pertences seguros e acessíveis durante toda a viagem.',
  amen_luggage_detail: 'Generosos compartimentos sob o ônibus e compartimentos superiores fornecem amplo espaço para todas as suas malas.',
  amen_learnMore: 'Saiba mais',
  amen_showLess: 'Ver menos',
  amen_gallery_eyebrow: 'Entre e Veja',
  amen_gallery_title1: 'Tour',
  amen_gallery_title2: 'Interior',
  amen_gallery_subtitle: 'Faça um tour visual por cada canto da cabine — desde o momento em que você embarca até o assento em que se instala.',
  amen_gal1_label: 'Cabine Principal',
  amen_gal1_caption: 'Fileiras de assentos de couro premium espaçosos percorrem toda a extensão da cabine.',
  amen_gal2_label: 'Assentos Premium',
  amen_gal2_caption: 'Couro de grão completo com suporte lombar e controles de reclinação individuais ao seu alcance.',
  amen_gal3_label: 'Entretenimento',
  amen_gal3_caption: 'Telas touchscreen HD pessoais em cada assento com filmes, música e conteúdo selecionado.',
  amen_gal4_label: 'Carga e Conectividade',
  amen_gal4_caption: 'Portas de carregamento USB-A e USB-C integradas em cada apoio de braço para que você nunca fique sem bateria.',
  amen_gal5_label: 'Controle de Clima',
  amen_gal5_caption: 'Ventiladores individuais superiores permitem que cada passageiro ajuste sua temperatura perfeita.',
  amen_gal6_label: 'Armazenamento de Bagagem',
  amen_gal6_caption: 'Generosos compartimentos sob o piso mantêm sua bagagem segura durante toda a viagem.',
  amen_zoom_hint: 'Clique para ampliar',
  amen_cta_eyebrow: 'Pronto para Viajar?',
  amen_cta_title: 'Experiencie Cada Comodidade na sua Próxima Viagem',
  amen_cta_subtitle: 'Reserve seu assento hoje e descubra por que a Phoenix Transportation é o principal serviço de luxo interurbano do Panamá.',
  amen_cta_btn1: 'Ver Horários e Reservar',
  amen_cta_btn2: 'Fale Conosco',

  // Fleet Page
  fleet_page_eyebrow: 'Nossa Frota',
  fleet_page_h1_line1: 'Conheça os Coaches que',
  fleet_page_h1_line2: 'Definem a Viagem',
  fleet_page_subtitle: 'Dois coaches de luxo de última geração — construídos para o desempenho, projetados para o conforto e mantidos à perfeição em cada rota entre a Cidade do Panamá e Chitré.',
  fleet_page_stat1_label: 'Coaches de Luxo',
  fleet_page_stat2_label: 'Assentos Totais',
  fleet_page_stat3_label: 'Dias por Ano',
  fleet_page_stat4_label: 'Rota de Luxo',
  fleet_page_badge_flagship: 'Principal',
  fleet_page_badge_newest: 'Mais Novo',
  fleet_page_seats_label: 'Assentos',
  fleet_page_tab_exterior: 'exterior',
  fleet_page_tab_interior: 'interior',
  fleet_page_tab_seat: 'Assentos',
  fleet_page_specs_title: 'Especificações',
  fleet_page_features_title: 'Recursos a Bordo',
  fleet_page_seatmap_title: 'Mapa de Assentos',
  fleet_page_seatmap_note: 'Passe o cursor para destacar · Todos os assentos são de classe premium',
  fleet_page_spec_capacity: 'Capacidade',
  fleet_page_spec_year: 'Ano',
  fleet_page_spec_length: 'Comprimento',
  fleet_page_spec_engine: 'Motor',
  fleet_page_spec_climate: 'Clima',
  fleet_page_spec_wifi: 'Conectividade',
  fleet_page_spec_entertainment: 'Entretenimento',
  fleet_page_spec_charging: 'Carregamento',
  fleet_page_spec_val_capacity: '57 Assentos',
  fleet_page_spec_val_engine: 'Diesel Euro VI',
  fleet_page_spec_val_climate: 'A/C de Zona Dupla',
  fleet_page_spec_val_wifi: 'Wi-Fi via Satélite',
  fleet_page_spec_val_entertainment: 'Telas HD Individuais',
  fleet_page_spec_val_charging: 'USB-A + USB-C por Assento',
  fleet_page_highlight_0: 'Assentos de couro premium totalmente reclináveis',
  fleet_page_highlight_1: 'Telas touchscreen HD individuais de entretenimento',
  fleet_page_highlight_2: 'Wi-Fi a bordo com tecnologia via satélite',
  fleet_page_highlight_3: 'Ar-condicionado de precisão de zona dupla',
  fleet_page_highlight_4: 'Carregamento rápido USB-A e USB-C em cada assento',
  fleet_page_highlight_5: 'Grandes compartimentos de bagagem sob o piso',
  fleet_page_highlight_6: 'Banheiro a bordo',
  fleet_page_highlight_7: 'Assistente bilíngue profissional em cada viagem',
  fleet_page_bus1_name: 'Phoenix I',
  fleet_page_bus1_tagline: 'A Experiência Principal',
  fleet_page_bus2_name: 'Phoenix II',
  fleet_page_bus2_tagline: 'Igualmente Luxuoso, Sempre Pronto',
  fleet_page_safety_eyebrow: 'Sua Segurança, Nossa Prioridade',
  fleet_page_safety_title1: 'Construídos sobre uma',
  fleet_page_safety_title2: 'Base de Segurança',
  fleet_page_safety_0_title: 'Certificação de Segurança',
  fleet_page_safety_0_desc: 'Cada veículo possui certificação completa da autoridade de transporte panamenha e é inspecionado mensalmente.',
  fleet_page_safety_1_title: 'Motoristas Profissionais',
  fleet_page_safety_1_desc: 'Todos os motoristas têm no mínimo 10 anos de experiência em longas distâncias e passam por verificações regulares de bem-estar.',
  fleet_page_safety_2_title: 'Monitoramento por Câmeras',
  fleet_page_safety_2_desc: 'Câmeras internas e externas operam durante toda a viagem para a segurança dos passageiros.',
  fleet_page_safety_3_title: 'Primeiros Socorros',
  fleet_page_safety_3_desc: 'Kits de primeiros socorros certificados e equipe treinada presentes em cada viagem.',
  fleet_page_safety_4_title: 'Rastreamento GPS',
  fleet_page_safety_4_desc: 'Rastreamento GPS em tempo real em cada coach, visível para a central 24/7.',
  fleet_page_safety_5_title: 'Supressão de Incêndio',
  fleet_page_safety_5_desc: 'Sistemas automáticos de supressão de incêndio instalados em ambos os coaches.',
  fleet_page_cta_eyebrow: 'Pronto para Embarcar?',
  fleet_page_cta_title: 'Reserve seu Assento no Phoenix I ou Phoenix II',
  fleet_page_cta_subtitle: 'Uma partida diária da Cidade do Panamá e de Chitré às 4:00 AM. Os assentos são limitados — garanta o seu hoje.',
  fleet_page_cta_btn1: 'Ver Horários e Reservar',
  fleet_page_cta_btn2: 'Explorar Comodidades',
  fleet_page_seatmap_front: 'Frente',
  fleet_page_seatmap_rear: 'Fundo',
  fleet_page_seatmap_door: 'Porta',
  fleet_page_seatmap_all_premium: 'Todos os assentos são de classe premium',
};

export default pt;
